export default __webpack_public_path__ + "assets/audios/50520f81a12c839e252667caa59d6896.mp3";